<template>
<div id="page-solicitud-pago-garantia" >
  <div>
    <v-breadcrumbs :items="breadcrumbs" >
      <v-icon slot="divider" >forward</v-icon>
    </v-breadcrumbs>
  </div>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12>
        <base-material-card color="primary" icon="library_books" title="Solicitud de Pago Garantía" class="elevation-1 px-5 py-3" >
          <v-card-actions>

            <v-spacer></v-spacer>
            <v-dialog v-model="modal" max-width="80%" >
              <v-card>
                <v-card-title>
                  <v-card class="primary white--text titulomodal" >
                    <v-icon class="white--text" >{{update ? "edit" : "add"}}</v-icon>&nbsp;
                    <span class="subheading" >
                      <strong>Detalles de la Carga</strong>
                    </span>
                  </v-card>
                  <v-spacer></v-spacer>
                  <v-btn icon @click.native="modal = false" class="close_modal" >
                    <v-icon class="white--text" >cancel</v-icon>
                  </v-btn>
                </v-card-title>

                <v-card-text>
                  <v-form ref="form" lazy-validation>
                    <v-container gridd-list-md>
                      <v-layout wrap>
                        <v-flex xs6>
                          <v-text-field label="Beneficiario" v-model="model.beneficiario" ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                    <br>
                    <v-container grid-list-md>
                      <v-layout wrap v-for="(detalle, i) in model.detalles" :key="i" >
                        <v-flex xs1>
                          <v-text-field disabled='disabled' label="Num. Bultos" v-model="detalle.num_bultos" ></v-text-field>
                        </v-flex>
                        <v-flex xs1>
                          <v-text-field disabled='disabled' label="Tipo" v-model="detalle.tipo_bultos" ></v-text-field>
                        </v-flex>
                        <v-flex xs1>
                          <v-text-field disabled='disabled' label="Peso" v-model="detalle.peso_neto" ></v-text-field>
                        </v-flex>
                        <v-flex xs1>
                          <v-text-field disabled='disabled' label="Vol (CBM)" v-model="detalle.vol_cbm" ></v-text-field>
                        </v-flex>
                        <v-flex xs3>
                          <v-text-field label="Importe de Garantia" v-model="detalle.importe_garantia" ></v-text-field>
                        </v-flex>
                        <v-flex xs2>
                          <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field v-on="on" v-model="detalle.fecha_solicitud" label="Fecha de Solicitud" color="secondary" prepend-icon="event" @blur="detalle.fecha_solicitud = parseDate(detalle.fecha_solicitud)" v-mask="'####-##-##'"
                                  :rules="[rules.required]" ></v-text-field>
                            </template>

                            <v-date-picker v-model="detalle.fecha_solicitud" color="secondary"  scrollable locale="es-mx" @input="menu1 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu1 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex xs2>
                          <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field v-on="on" v-model="detalle.fecha_pago" label="Fecha de Pago" color="secondary" prepend-icon="event" @blur="detalle.fecha_pago = parseDate(detalle.fecha_pago)" v-mask="'####-##-##'" :rules="[rules.required]" >
                              </v-text-field>
                            </template>

                            <v-date-picker v-model="detalle.fecha_pago" color="secondary"  scrollable locale="es-mx" @input="menu2 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu2 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn @click.native="modal=false" >
                    <v-icon>cancel</v-icon> Cancelar
                  </v-btn>
                  <v-btn color="success" @click.native="updateTrafico()" >
                    <v-icon>done</v-icon>
                    {{ update ? "Actualizar" : "Guardar" }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card-actions>

          <v-card-text>
            <div id="datagrid" v-on:keyup.enter="$refs.pagination_pw.filterData()" >

              <v-client-table ref="vuetable" :data="traficos.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                <template slot="noResults" >
                  <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                </template>
                <template slot="eta" slot-scope="props" >
                  <div class="" >
                    {{parseDate(props.row.eta)}}
                  </div>
                </template>
                <template slot="actions" slot-scope="props" >
                  <v-speed-dial :id="props.row.id" direction="left" open-on-hover :style="'text-align:center;'" >
                    <template v-slot:activator>
                      <v-btn :id="props.row.id" x-small fab dark color="primary" >
                        <v-icon>reorder</v-icon>
                      </v-btn>
                    </template>

                    <v-btn x-small fab dark color="warning" @click.native="getTrafico(props.row.referencia)" title="Editar Registro" v-tippy>
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </v-speed-dial>
                </template>
              </v-client-table>
              <template>
                <div v-if="pwPagination.total > 0" >
                  <div class="mt-3" >
                    <PaginacionComponent ref="pagination_pw" :total='pwPagination.total' :links="pwPagination.links" :items="traficos" :options="pwPagination.options" ></PaginacionComponent>
                  </div>
                </div>
              </template>
            </div>
          </v-card-text>
          </v-card>
        </base-material-card>
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import PaginacionComponent from '@/components/PaginacionComponent.vue';

export default {
  components: {
    "PaginacionComponent": PaginacionComponent,
  },
  created: function() {
    this.model.rfc = this.$local_storage.get("rfc");
    this.getTraficos();
  },
  mounted: function() {
    this.model_filters = this.$refs.vuetable.query
  },
  watch: {
    model_filters: {
      handler(val) {
        this.pwPagination.options.filters = {
          rfc: this.model.rfc,
          referencia: {
            '$regex': this.model_filters.referencia
          }
        }
      },
      deep: true
    }
  },
  data() {
    return {
      model_filters: '',
      name: "datagrid",
      columns: [
        "seguidor",
        "referencia",
        "tipo_oper",
        "aduana",
        "AA",
        "embarcador_destinatario",
        "manifiesto",
        "contrs",
        "contenedor",
        "eta",
        "operador",
        "mensaje",
        "estado",
        "actions"
      ],
      rules: {
        required: v => !!v || "Este campo es requerido",
        numeric: value => {
          const pattern = /^[\d]*$/;
          return pattern.test(value) || "Solo se permiten números";
        }
      },
      show_loading: true,
      options: {
        filterable: ["referencia"],
        sortable: ["seguidor"],

        headings: {
          seguidor: "Seguidor",
          referencia: "Referencia",
          tipo_oper: "Tipo Operación",
          aduana: "Aduana",
          AA: "AA",
          embarcador_destinatario: "Embarcador",
          manifiesto: "Manifiesto",
          contrs: "#Contenedores",
          contenedor: "Contenedor",
          eta: "ETA",
          operador: "Operador",
          mensaje: "Mensaje",
          estado: "Estado",
          actions: "Operaciones"
        }
      },
      show_loading: true,
      breadcrumbs: [
        {
            text: "Inicio",
            disabled: false,
            href: "/trafico_index"
        },
        {
            text: "Administración",
            disabled: true,
            href: ""
        },
        {
          text: "Solicitud de Pago Garantía",
          disabled: true,
          href: ""
        }
      ],
      menu1: false,
      menu2: false,
      title: "",
      modal: false,
      update: false,
      model: {
        importe_garantia: "",
        fecha_solicitud: "",
        eir: "",
        fecha_retorno: "",
        rfc: ""
      },
      search: "",
      traficos: {
        items: []
      },
      model_filters: '',
      pwPagination: {
        total: 0,
        links: {
          url: this.$hostname + "traficos/listado_solicitudes/",
          next: '',
          prev: '',
        },
        options: {
          tipo: 1,
          size: 10,
          loading: this.showLoading,
          filters: {
            rfc: '',
          }
        }
      },
    };
  },

  methods: {
    openModal: function(type) {
      if (type === 1)
        this.update = false;
      else
        this.update = true;

      this.modal = true;
    },
    getTraficos: function() {
      axios
        .post(this.$hostname + "traficos/listado_solicitudes/", {
          'rfc': this.model.rfc
        })
        .then(response => {
          // let datos = [];
          // datos = response.data.filter(trafico => trafico.movimientos[trafico.movimientos.length > 0 ? trafico.movimientos.length-1 :0].estado == "Confirmacón de Carga");
          this.traficos.items = response.data.results;

          this.pwPagination.total = response.data.count;
          this.pwPagination.links.next = response.data.next;
          this.pwPagination.links.prev = response.data.previous;
          this.$root.$dialogLoader.hide();

        })
        .catch(error => {
          console.log(error)
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los traficos.",
            footer: ""
          });
        });
    },
    getTrafico: function(referencia) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

      axios
        .post(this.$hostname + "traficos/obtener/", {
          'rfc': this.model.rfc,
          "referencia": referencia
        })
        .then(response => {
          let bene = '';
          if (response.data.beneficiario == '' || response.data.beneficiario == null) {
            bene = response.data.transportista_master;
          } else {
            bene = response.data.beneficiario;
          }

          for (var i = 0; i < response.data.detalles_carga.length; i++) {
            response.data.detalles_carga[i].fecha_pago = this.parseDate(response.data.detalles_carga[i].fecha_pago);
            response.data.detalles_carga[i].fecha_solicitud = this.parseDate(response.data.detalles_carga[i].fecha_solicitud);
          }

          console.log(response.data.beneficiario);
          this.model = {
            'detalles': response.data.detalles_carga,
            'rfc': this.$local_storage.get("rfc"),
            'beneficiario': bene,
            'referencia': response.data.referencia
          };

          this.$root.$dialogLoader.hide();
          this.openModal(2);
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener el trafico",
            footer: ""
          });
        });
    },
    updateTrafico: function() {
      if (this.$refs.form.validate()) {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.model.detalles.forEach(data => {
          for (let attr in data) {
            if (data[attr] == '' || data[attr] == null) {
              delete data[attr];
            }

            if (attr == 'fecha_solicitud' || attr == 'fecha_pago') {
              if (data[attr] != '' && data[attr] != null && data[attr] != undefined) {
                data[attr] = data[attr] + "T00:00:01"
              }
            }

          }
          console.log(data);
        });
        axios
          .put(this.$hostname + "traficos/solicitud_garantia/", this.model)
          .then(response => {
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "El Trafico se actualizó correctamente.",
              footer: ""
            });

            this.$root.$dialogLoader.hide();
            this.getTraficos();
            this.modal = false;
          })
          .catch(error => {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al actualizar el trafico",
              footer: ""
            });
          });
      }
    },
    parseDate(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
  }
};
</script>
